import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { primaryNavLinks } from '@/config/navLinks';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <nav
        className={`w-full transition-all duration-300 border-b ${
          scrolled
            ? 'bg-white/95 backdrop-blur-md border-slate-200'
            : 'bg-white/90 backdrop-blur-sm border-slate-100'
        }`}
      >
        <div className="max-w-6xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-[70px]">

          <Link
            to="/"
            className="flex items-center gap-3 cursor-pointer flex-shrink-0"
            onClick={() => setMobileOpen(false)}
          >
            <div className="w-10 h-10 flex items-center justify-center bg-primary rounded-xl">
              <i className="ri-fire-fill text-white text-lg" />
            </div>
            <div className="leading-tight text-left">
              <span className="block text-sm font-bold text-slate-900">Kombi Kurumsal Servis</span>
              <span className="block text-[11px] text-primary font-semibold">Kombi Servisi</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-6" aria-label="Ana menü">
            {primaryNavLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-sm font-medium text-slate-600 hover:text-primary transition-colors whitespace-nowrap"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <a
            href="tel:05332836679"
            className="hidden md:inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors whitespace-nowrap flex-shrink-0"
          >
            <i className="ri-phone-fill" />
            0533 283 66 79
          </a>

          <div className="md:hidden flex items-center gap-2">
            <a
              href="tel:05332836679"
              className="w-9 h-9 flex items-center justify-center bg-primary text-white rounded-full hover:bg-primary-dark transition-colors"
              aria-label="Ara: 0533 283 66 79"
            >
              <i className="ri-phone-fill text-base" />
            </a>
            <button
              type="button"
              className="w-9 h-9 flex items-center justify-center text-slate-600 border border-slate-200 rounded-full hover:border-primary hover:text-primary transition-colors cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-expanded={mobileOpen}
              aria-label={mobileOpen ? 'Menüyü kapat' : 'Menüyü aç'}
            >
              <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} />
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-slate-100 px-4 py-4 flex flex-col gap-1">
            {primaryNavLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setMobileOpen(false)}
                className="text-left text-sm font-medium text-slate-700 hover:text-primary py-2.5 border-b border-slate-50"
              >
                {l.label}
              </Link>
            ))}
            <a
              href="tel:05332836679"
              className="mt-3 inline-flex items-center justify-center gap-2 bg-primary text-white text-sm font-bold px-5 py-3 rounded-full"
            >
              <i className="ri-phone-fill" />
              0533 283 66 79
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
